import React, { useEffect, useRef, useState } from "react";
import { Stack, Tooltip } from "@mui/material";
import styled from "styled-components";
import TimeSplitter from "../utils/time-splitter";

const JobContainer = styled(Stack)`
    width: 100%;
`;

const JobText = styled.p`
    font-size: 12px;
    margin: 2px;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
`;

const JobTimeText = styled.p`
    font-size: 12px;
    margin: 2px;
    white-space: nowrap;
    color: ${({ theme, jobDuration, avgDuration }) => {
        if (avgDuration === 0 || avgDuration === null) return theme.palette.text.disabled;
        if (jobDuration < avgDuration) return theme.palette.primary.main;
        if (jobDuration > avgDuration) return theme.palette.warning.dark;
        if (jobDuration === avgDuration) return theme.palette.text.secondary;
        return theme.palette.text.disabled;
    }};
`;

const JobComponent = ({ job, durationMode }) => {
    const [isOverflowed, setIsOverflowed] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        const checkOverflow = () => {
            if (textRef.current) {
                const element = textRef.current;
                setIsOverflowed(element.scrollWidth > element.clientWidth);
            }
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);

        return () => {
            window.removeEventListener("resize", checkOverflow);
        };
    }, []);

    return (
        <JobContainer direction="row" justifyContent="space-between">
            <Tooltip title={isOverflowed ? job.name : ""}>
                <JobText ref={textRef}>{job.name}</JobText>
            </Tooltip>
            {durationMode === "overall" ? (
                <Tooltip title={`was ${TimeSplitter(job.baselineAvgDuration, "chrono")}`}>
                    <JobTimeText
                        jobDuration={job.avgDuration}
                        avgDuration={job.baselineAvgDuration}
                    >
                        {TimeSplitter(job.avgDuration, "stage-duration")}
                    </JobTimeText>
                </Tooltip>
            ) : (
                <Tooltip title={`was ${TimeSplitter(job.baselineSumDuration, "stage-duration")}`}>
                    <JobTimeText
                        jobDuration={job.sumDuration}
                        avgDuration={job.baselineSumDuration}
                    >
                        {TimeSplitter(job.sumDuration, "stage-duration")}
                    </JobTimeText>
                </Tooltip>
            )}
        </JobContainer>
    );
};

export default JobComponent;
